import { Button, ButtonProps, Text } from '@chakra-ui/react';

interface Props extends ButtonProps {
    name: string;
}

export default function BuyButton({ name, ...props }: Props) {
    return (
        <Button
            variant="none"
            color="white"
            background="linear-gradient(to right, rgba(161, 231, 60, 0.8), rgba(90, 135, 29, 1));"
            fontSize="16px"
            fontWeight="500"
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap="12px"
            width="100%"
            padding="25px 30px"
            {...props}>
            <Text>{name}</Text>
        </Button>
    );
}
